"use client";

import { cn } from "@ui/lib";
import { Badge } from "@ui/components/badge";
import {
  FREQUENCIES,
  marginError,
  mdcPct,
  qualityRating,
} from "../lib/statistics";

const FREQ_COLORS: Record<string, { text: string; bar: string }> = {
  daily: { text: "text-emerald-500", bar: "bg-emerald-500" },
  three: { text: "text-amber-500", bar: "bg-amber-500" },
  weekly: { text: "text-rose-500", bar: "bg-rose-500" },
};

interface StatCardsProps {
  prompts: number;
  p: number;
  conf: number;
}

export function StatCards({ prompts, p, conf }: StatCardsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {FREQUENCIES.map((f) => {
        const total = prompts * f.runs;
        const me = marginError(total, p, conf);
        const m = mdcPct(total, p, conf);
        const quality = qualityRating(me);
        const barWidth = Math.max(4, Math.min(100, (1 - me / 50) * 100));
        const colors = FREQ_COLORS[f.key];

        return (
          <div
            key={f.key}
            className="relative overflow-hidden rounded-xl border bg-card p-5"
          >
            <div
              className={cn(
                "absolute inset-x-0 top-0 h-0.5",
                colors.bar,
              )}
            />

            <div className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
              {f.label}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              {f.freq} · {total} total obs
            </div>

            <div className={cn("mt-3 text-3xl font-bold", colors.text)}>
              ±{me.toFixed(1)}
              <span className="text-sm font-normal text-muted-foreground">%</span>
            </div>
            <div className="text-xs text-muted-foreground">Margin of error</div>

            <div className="mt-2 text-xs text-muted-foreground">
              Min. detectable change:{" "}
              <span className="font-medium text-foreground">
                {m.toFixed(1)}%
              </span>
            </div>

            <Badge status={quality.variant} className="mt-3">
              {quality.label}
            </Badge>

            <div className="mt-3 h-1 overflow-hidden rounded-full bg-border">
              <div
                className={cn("h-full rounded-full transition-all duration-500", colors.bar)}
                style={{ width: `${barWidth}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
